<ng-container [ngSwitch]="true">
  <ng-template [ngSwitchCase]="count === 1">
    <div class="counter fs-12px">1 {{ "comment" | localize | lowercase }}</div>
  </ng-template>
  <ng-template [ngSwitchCase]="count > 10">
    <div class="counter fs-12px">10+ {{ "comments" | localize | lowercase }}</div>
  </ng-template>
  <ng-template [ngSwitchDefault]>
    <div class="counter fs-12px">{{ count }} {{ "comments" | localize | lowercase }}</div>
  </ng-template>
</ng-container>
